import { useEffect, useState } from 'react';
import { fetchAssetGroups } from '../api/fetchAssetGroups';

let cachedGroupNames: Map<string, string> | null = null;

export const clearAssetGroupNamesCache = () => {
    cachedGroupNames = null;
};

const useAssetGroupNames = (enabled = true) => {
    const [groupNames, setGroupNames] = useState<Map<string, string>>(() => cachedGroupNames ?? new Map());

    useEffect(() => {
        if (!enabled) {
            setGroupNames(new Map());
            return;
        }
        if (cachedGroupNames) {
            setGroupNames(cachedGroupNames);
            return;
        }
        let cancelled = false;
        fetchAssetGroups().then(groups => {
            if (cancelled || !groups.length) {
                return;
            }
            cachedGroupNames = new Map(groups.map(group => [group.id, group.name]));
            setGroupNames(cachedGroupNames);
        });
        return () => {
            cancelled = true;
        };
    }, [enabled]);

    return groupNames;
};

export default useAssetGroupNames;
